// extracted by css-extract-rspack-plugin
export default {"indexCard":"IndexCard-module__indexCard__Pm9Cm4F"};